import { Time_Period } from '@occc/graphql';

export const LAST_VISIT_MAX_BY_PERIOD: Record<Time_Period, { max: number; errorMessage: string }> =
  {
    [Time_Period.Day]: { max: 90, errorMessage: 'Please enter 90 days or less' },
    [Time_Period.Week]: { max: 12, errorMessage: 'Please enter 12 weeks or less' },
    [Time_Period.Month]: { max: 3, errorMessage: 'Please enter 3 months or less' },
  };
